import React, { FC, useEffect, useState } from 'react'
import { BorderedPageLayout } from '../../../pages/BorderedPageLayout'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { ModalContentProps } from '../../Modal'
import { addToCart, clearCart, CartItemType } from '../../../features/cart/cartSlice'
import { CartItem } from '../../ListItems/CartItem'
import Skeleton from 'react-loading-skeleton'
import { YellowButton } from '../../YellowButton'
import useTheme from '../../../hooks/useAppColor'
import { AnalysisApi } from '../../../types/entities/analysis.types'
import { useNavigate } from 'react-router-dom'
import {QRCode} from 'antd'
import { handleTemplateSheetAnalysisInfoModal, handleTemplateSheetModal, handleDefaultTemplateSheetModal } from '../../../features/modals/modalsSlice'


export const TemplateSheetAnalysisModalContent: FC<ModalContentProps & {data: any}> = ({ handleModal, level, data}) => {
    const dispatch = useAppDispatch()
    const getTheme = useTheme()
    const navigate = useNavigate()
    const [imgURL, setImgURL] = useState<string>('')
    const cartItems = useAppSelector(state => state.cart.items)
    const products = useAppSelector(state => state.products.all)
    

     const addProduct = () => {
            dispatch(clearCart())
          
            if(data.analysis){
                data?.analysis.map((item: any) => {
                    dispatch(addToCart({ ...item as CartItemType }))
                })
                 dispatch(handleTemplateSheetModal())
            }

            if(data.list){
                data?.list.map((item: any) => {
                            let res: any = products.find((product: any) => product.id === item)
                            dispatch(addToCart({ ...res as CartItemType }))
                        })
                dispatch(handleDefaultTemplateSheetModal())
            }

            dispatch(handleTemplateSheetAnalysisInfoModal(null))
            navigate("order/cart")
    }
    
    let cartTotalPrice = 0;

    useEffect(() => {
               localStorage.setItem('cartItems', JSON.stringify(cartItems))
            },[cartItems])

    return (
        <BorderedPageLayout
            modal={{ level: level || 1 }}
            handleModal={handleModal}
            contentClassName='f-column gap-40'>
            <div className="d-f jc-between">
                <div onClick={handleModal} className="textButton fz-l">Закрыть</div>
                <p className={`fw-5 fz-l fw-6 ${getTheme("c-dark", "c-lg")}`}></p>
                <div className='f-025'></div>
            </div>
            <h2 className={`title ${getTheme("", "c-white")}`}>{data?.name}</h2>
            <div className="f-1 p-rel">     
                <div className="list p-rel w-100p f-column scrollableItemsList gap-10">
                    {data?.analysis ?
                        data?.analysis.map((item: any) => {
                            cartTotalPrice += item.cost
                            
                            return <CartItem key={item.id}
                                item={item}
                                del={false} />
                        })
                        :
                        <></>
                    }
                    {
                    data?.list ?
                        data?.list.map((item: any) => {
                            let res: any = products.find((product: any) => product.id === item)
                            cartTotalPrice += res.cost

                            return <CartItem key={res.id}
                                item={res}
                                del={false} />
                        })
                        :
                        <></>
                    }
                    
                </div>
            </div>
            <div className="p-rel">
                <p className={`${getTheme("c-dark", "c-white")} fz-l fw-9`}>Итого: {cartTotalPrice}&nbsp;₽</p>
            </div>
            {data?.url ?
                <>
                    <h2 className={`title ${getTheme("", "c-white")}`}>Ваш уникальный QR-код шаблона анализов:</h2>
                    <div className='d-f al-center jc-center gap 10'>
                        <QRCode
                            errorLevel="H"
                            bgColor={"#ffffff"}
                            value={data?.url ?? "exampple"}
                            icon="https://sun9-75.userapi.com/impg/MSPGg5lSkgWVXIPgCo1l5lnN6MkusQZ2nTL--A/5dNS8cD2DHc.jpg?size=1024x1024&quality=95&sign=343de730308753211d50289536ffacf4&type=album"
                        />
                    </div>
                </>
                :
                <></>
            }
            <YellowButton className='f-c-row gap-10' onClick={addProduct}>Добавить анализы из <br/>шаблона в корзину</YellowButton>
            
        </BorderedPageLayout>
    )
}
